// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"NonDisclosureToolTipWarning_buttonWrapper__wrve2","divider":"NonDisclosureToolTipWarning_divider__2JT1n"};